import { render, staticRenderFns } from "./TeamProfile.vue?vue&type=template&id=207e6165&scoped=true&"
import script from "./TeamProfile.vue?vue&type=script&lang=js&"
export * from "./TeamProfile.vue?vue&type=script&lang=js&"
import style0 from "./TeamProfile.vue?vue&type=style&index=0&id=207e6165&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207e6165",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('207e6165')) {
      api.createRecord('207e6165', component.options)
    } else {
      api.reload('207e6165', component.options)
    }
    module.hot.accept("./TeamProfile.vue?vue&type=template&id=207e6165&scoped=true&", function () {
      api.rerender('207e6165', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamMembers/TeamProfile.vue"
export default component.exports